import { ConversationPart, ConversationCell, Exploration, Cell } from '@/explore/types';

import {
  addConversationId,
  isConversationCell,
  isConversationPart,
  removeConversationId,
} from '../cell/conversation-cell';

export function insertConversationStart(
  exploration: Exploration,
  conversationCell: ConversationCell,
  cellId: string,
) {
  const referencedCellIndex = exploration.view.cells.findIndex((cell) => cell.id === cellId);
  if (referencedCellIndex === -1) {
    throw new Error(`Cell with id ${cellId} not found in exploration.`);
  }
  const referencedRowId = exploration.view.cells[referencedCellIndex].viewOptions?.rowId;
  let insertAt = referencedCellIndex;

  if (referencedRowId !== undefined) {
    // Find the last cell in the same row as the referenced cell
    for (let i = referencedCellIndex; i < exploration.view.cells.length; i++) {
      if (exploration.view.cells[i].viewOptions?.rowId === referencedRowId) {
        insertAt = i;
      }
    }
  }

  return {
    ...exploration,
    view: {
      ...exploration.view,
      cells: exploration.view.cells.reduce<Cell[]>((result, c, idx) => {
        if (idx === referencedCellIndex) {
          result.push(addConversationId(c, conversationCell.conversationId));
        } else {
          result.push(c);
        }
        if (insertAt === idx) {
          result.push(conversationCell);
        }
        return result;
      }, []),
    },
  };
}

export function removeConversationEditFlow(
  exploration: Exploration,
  chatCellId: string,
  cellToEdit?: ConversationPart,
) {
  return {
    ...exploration,
    view: {
      ...exploration.view,
      cells: exploration.view.cells
        .filter((c) => c.id !== chatCellId)
        .map((c) => {
          if (cellToEdit?.id === c.id) {
            return removeConversationId(cellToEdit);
          }
          return c;
        }),
    },
  };
}

export function replaceConversationId(
  exploration: Exploration,
  oldConversationId: string,
  newConversationId: string,
) {
  return {
    ...exploration,
    view: {
      ...exploration.view,
      cells: exploration.view.cells.map((cell) => {
        if (
          (isConversationCell(cell) || isConversationPart(cell)) &&
          cell.conversationId === oldConversationId
        ) {
          return {
            ...cell,
            conversationId: newConversationId,
          };
        }
        return cell;
      }),
      canvas: exploration.view.canvas
        ? {
            edges: exploration.view.canvas.edges,
            nodes: exploration.view.canvas.nodes.map((node) => {
              if (node.id === oldConversationId) {
                return { ...node, id: newConversationId };
              }
              return node;
            }),
          }
        : undefined,
    },
  };
}
